<script>
import ElementsTooltipSingleton from "@/components/elements/ElementsTooltipSingleton.vue";

export default{
    components : {
        ElementsTooltipSingleton,
    },
    props : {
        selectOption : Array,
        name : String,
        modelValue : [ String, Boolean, Number ],
        readonly : Boolean,
        description: String,
        useTooltip: Boolean,
    },
    emits : [ 'update:modelValue', 'changeButton'],
    methods : {
        // -----------------------------------------------------------------------------
        loadTooltip(ele, msgFn, options ){
            this.__tooltipComponent__hidden__.loadBasic(ele, msgFn, options);
        },
        loadTooltipElementReady(ele){
            if( ele == null ) return; // auto-reload, so element can be null sometime.
            this.__tooltipComponent__hidden__ = ele;
        },
        // -----------------------------------------------------------------------------
        toggleButton( item ){
            const self = this;
            if( self.readonly ) return;
            self.$emit('update:modelValue', item);
            self.$emit('changeButton');
        }
    },
    computed:{
        selectedButton(){
            const self = this;
            let selected = self.modelValue
            
            if( ! self.valueArray.includes(self.modelValue) || !self.modelValue  ){
                selected = self.valueArray[0];
            }
            
            self.$emit('update:modelValue', selected);
            return selected; 
        },
        valueArray(){
            const self = this;
            return self.selectOption.map( option => option.value );
        } 
    },
}

</script>

<template>
    <div class="flex flex-col">
        <ElementsTooltipSingleton
            :ref="(el)=>{ loadTooltipElementReady(el); }"
        />

        <label> 
            <div class="text-[14px] text-[#504F54] font-bold"> {{ name }} </div>
            <p class="text-gray-400 text-[14px]"> {{ description }} </p>
        </label>
        <div class="flex gap-2">
            <template v-for="(item, index) in selectOption" :key="index">
                <button
                    v-if="item.value === modelValue"
                    class="h-[44px] w-[160px] px-2 font-caption-md-regular border-1 border-border-basic-2 rounded-2 blu hover-color"
                    :class="{ 'bg-background-basic-3': readonly }"
                    @click="toggleButton(item.value)"
                    :ref="useTooltip ? (el)=>{ loadTooltip(el, ()=>{
                        return item.tooltip
                    })} : ''">
                    {{ item.text }}
                </button>

                <button
                    v-else
                    class="h-[44px] w-[160px] px-2 font-caption-md-regular border-1 border-border-basic-2 rounded-2 hover-color"
                    :class="{ 'bg-background-basic-3': readonly }"
                    @click="toggleButton(item.value)"
                    :ref="useTooltip ? (el)=>{ loadTooltip(el, ()=>{
                        return item.tooltip
                    })} : ''">
                    {{ item.text }}
                </button>
            </template> 
        </div>
    </div>
</template>
<style scoped>
    .blu{
        font-weight: 500;
        @apply border-primary-3 text-primary-3
    }
    .hover-color:hover {
        border: none;
        @apply bg-primary-1 text-primary-3
    }
</style>
